function onScroll() {
    const block = document.getElementById("live");
    const header = document.querySelector(".sheet-header");

    if (!block || !header) {
        return;
    }

    block.style.top = header.getBoundingClientRect().top + 80 + "px";
}

function initListener() {
    window.addEventListener("scroll", onScroll, { passive: true });
    document.body.addEventListener("scroll", onScroll, { passive: true });
    document.body.addEventListener("live.update", onScroll);

    onDomReady.then(onScroll);
}

const updateScroll = onScroll;

export { initListener, updateScroll };
